import React, { useEffect, useRef, useState } from "react";
import PinInput from "react-pin-input";
import { resendOtp, validateOtp } from "../../api.js";
import { useNavigate } from "react-router";
import Button from "../../Common/Button/Button.js";
import worker_script from "./Worker_script.js";
import "./otpInput.css";
import { useRoleFeature } from "../../context/RoleFeatureContext.js";
import { CookieUtils } from "../../axios.config.js";
const OTP_LENGTH = 6;
const INITIAL_TIMER = 180;

const OtpInputBox = ({
  hashId,
  setHashId,
  setStep,
  AccountVerified,
  handleSuccessfulLogin,
}) => {
  const [time, setTime] = useState(INITIAL_TIMER);
  const [otp, setOtp] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const workerRef = useRef();
  const pinInputRef = useRef(null);
  const navigate = useNavigate();
  const username = CookieUtils.get("username");
  const { setRoleFeatureList } = useRoleFeature();

  useEffect(() => {
    workerRef.current = new Worker(worker_script);
    workerRef.current.onmessage = (event) => {
      const { time } = event.data;
      setTime(time);
      if (time === 0) workerRef.current.postMessage({ turn: "off" });
    };

    workerRef.current.postMessage({ turn: "on" });
    return () => workerRef.current.terminate();
  }, []);

  const validateOtpInput = (otp) => {
    if (!otp) return "Please enter OTP";
    if (otp.length !== OTP_LENGTH)
      return `Please enter ${OTP_LENGTH} digit OTP`;
    if (!/^\d+$/.test(otp)) return "OTP must contain only numbers";
    return "";
  };

  const handleResend = async () => {
    try {
      pinInputRef.current?.clear();
      setOtp("");
      setErrorMessage("");
      setTime(INITIAL_TIMER);
      workerRef.current.postMessage({ turn: "on" });

      const body = { username, hashID: hashId };
      const res = await resendOtp(body);

      if (res.status === 200 && res.data?.data?.hashID) {
        setHashId(res.data.data.hashID);
      } else {
        throw new Error(res.data?.data?.message || "Failed to resend OTP");
      }
    } catch (error) {
      setErrorMessage(error.message || "Something went wrong");
    }
  };

  const handleConfirmButton = async (e) => {
    e.preventDefault();
    const validationError = validateOtpInput(otp);
    if (validationError) {
      setErrorMessage(validationError);
      return;
    }

    try {
      setIsSubmitting(true);
      setErrorMessage("");

      const body = { otp, hashID: hashId };
      const res = await validateOtp(body);

      if (!res.data?.data) {
        throw new Error("Invalid response from server");
      }

      if (res.data.data.code === 200) {
        const { authKey } = res.data.data;

        if (authKey?.roleFeatureList) {
          setRoleFeatureList(authKey.roleFeatureList);
          CookieUtils.set("roleFeatureList", authKey.roleFeatureList, 1);
          localStorage.setItem("roleFeatureList", JSON.stringify(authKey.roleFeatureList));
        }

          if (
            authKey &&
            handleSuccessfulLogin &&
            typeof handleSuccessfulLogin === "function" &&
            AccountVerified !== false
          ) {
            handleSuccessfulLogin(authKey);
        }

        if (AccountVerified === true) {
          navigate("/");
        } else if (AccountVerified === false) {
          setStep("step4");
        } else {
          setStep("step3");
        }
      } else {
        throw new Error(res.data.data.message || "OTP validation failed");
      }
    } catch (error) {
      setErrorMessage(error.message || "Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };

  const inputStyle = {
    spinInput: {
      textAlign: "center",
      width: "42px",
      height: "44px",
      background: "#FFFFFF",
      borderRadius: "6px",
      fontWeight: "bold",
      fontSize: "14px",
      color: "#3C404A",
    },
  };

  return (
    <form onSubmit={handleConfirmButton}>
      <PinInput
        ref={pinInputRef}
        length={OTP_LENGTH}
        type="numeric"
        inputMode="number"
        onChange={(value) => {
          setOtp(value);
          setErrorMessage("");
        }}
        onComplete={(value) => {
          setOtp(value);
          setErrorMessage("");
        }}
        inputStyle={inputStyle.spinInput}
        inputFocusStyle={{ border: "1px solid #3C404A" }}
        autoSelect
        regexCriteria={/[0-9]/}
      />
      <div className="expiresdiv">
        {time > 0 ? (
          <span className="expiresdivspan">Expires in {time}s</span>
        ) : (
          <span
            className="resendotpspan"
            onClick={handleResend}
            style={{ cursor: "pointer" }}
          >
            Resend OTP
          </span>
        )}
      </div>
      {errorMessage && <div className="errorMessage">{errorMessage}</div>}
      <Button
        type="submit"
        loading={isSubmitting}
        handleClick={handleConfirmButton}
        heading="Confirm OTP"
        width="140px"
        disabled={isSubmitting}
      />
    </form>
  );
};

export default OtpInputBox;
